import { initReassuranceDrawer } from '../shared/reassuranceDrawer';
import { sendButtonClick } from '../utils/tracking/tracking';
const selectorName = {
  calendarPageContainer: '#calendarPageId',
  goGoCalendarPageButton: 'button[name="calendarPageBtn"]'
};
const trackingButton = {
  bookingName: 'equipment rental reservation on PDP',
  bookingValue: 'Book'
};
export class EquipmentRentalProductBooking {
  constructor() {
    try {
      this.initCalendarPageCta();
    } catch (error) {
      console.error('Failed to initialize booking CTA:', error);
    }
    try {
      initReassuranceDrawer();
    } catch (error) {
      console.error('Failed to initialize reassurance drawer:', error);
    }
    this.changeStoreBtns = document.querySelectorAll('.js-choose-store');
    if (this.changeStoreBtns) {
      for (const changeStoreBtn of this.changeStoreBtns) {
        changeStoreBtn.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          window.dispatchEvent(new CustomEvent('openStoreContextLayerInSearchMode'));
        }, {
          capture: true
        });
      }
    }
  }
  initCalendarPageCta() {
    const container = document.querySelector(selectorName.calendarPageContainer);
    if (!container) {
      return;
    }
    const dataInfo = (container.getAttribute('data-info') || '').split('|');
    this.refLM = dataInfo[0] || '';
    this.storeId = dataInfo[1] || '';
    this.goGoCalendarPageButton = container.querySelector(selectorName.goGoCalendarPageButton);
    if (this.goGoCalendarPageButton) {
      this.goGoCalendarPageButton.addEventListener('click', () => this.onGoToCalendarPageClick());
    }
  }
  onGoToCalendarPageClick() {
    sendButtonClick(trackingButton.bookingName, trackingButton.bookingValue);
    const url = `[ALIAS::equipmentRentalBookingSelection]?productId=${this.refLM}`;
    window.open(url, '_self');
  }
}
document.addEventListener('DOMContentLoaded', function () {
  try {
    new EquipmentRentalProductBooking();
  } catch (error) {
    console.error('Failed to initialize EquipmentRentalProductBooking:', error);
  }
});